import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./SubTitle.css";
import "./SubTitleTwo.css";

export default class SubTitleTwo extends React.Component<
  { title: string; helpText?: string },
  {}
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="subtitle-two-container">
        <span>{this.props.title}</span>
        {this.props.helpText && (
          <div className="info-icon-container">
            <FontAwesomeIcon
              icon={faQuestionCircle}
              size="1x"
              onClick={() => {}}
              className="back-element-icon"
            />
            <div className="info-text-container">
              <div className="info-text-triangle"></div>
              <div className="info-text-inner-container">
                {this.props.helpText}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
